var e={height:{value:"100%"}};export{e as countrycodeselect};
//# sourceMappingURL=countryCodeSelect.js.map
